export type CalculateSeatChangeImpactDto = {
  deltaSeats: number;
  operation: "add" | "remove";
  roles?: string[];
  practitionerName?: string;
  practitionerId?: string;
};

export type PriceDetailsDto = {
  amountCents: number;
  currency: string;
};

export type BillingLedgerEntry = {
  _id: string;
  id: string;
  orgId: string;
  type: "proration" | "credit";
  amountCents: number;
  currency: string;
  description: string;
  status: "pendingConfirmation" | "confirmed" | "cancelled" | "processed";
  eventType:
    | "addSeat"
    | "removeSeat"
    | "tierUpgrade"
    | "tierDowngrade"
    | "addAddon"
    | "removeAddon"
    | "recurringCharge"
    | "recurringFailure"
    | "recurringCancellation";
  deltaSeats?: number;
  proposedTier?: string;
  currentMonthlyBillCents: number;
  newMonthlyBillCents: number;
  increaseCents: number;
  proratedAmountCents: number;
  prorationFactor?: number;
  periodStart?: Date;
  periodEnd?: Date;
  effectiveDate?: Date;
  oldQuantity?: number;
  newQuantity?: number;
  oldUnitPriceCents?: number;
  newUnitPriceCents?: number;
  processor: "stripe" | "dimepay";
  processorChargeId?: string;
  processorInvoiceId?: string;
  processorPlanId?: string;
  reconciliationStatus: "unreconciled" | "reconciled" | "partial";
  eventTimestamps?: string[];
  timestamp: Date;
  createdAt: Date;
  updatedAt: Date;
};

export type CapabilityDiffItem = {
  key: string;
  displayName: string;
};

export type SeatChangeImpactResponseDto = {
  willChangeTier: boolean;
  currentTier: string;
  newTier: string;
  currentPricePerSeatCents: number;
  newPricePerSeatCents: number;
  currentSeatCount: number;
  newSeatCount: number;
  currentPrice: PriceDetailsDto;
  newPrice: PriceDetailsDto;
  totalDifferenceCents: number;
  proratedAmountCents: number;
  /** Estimated processing fee in cents when passed to customer */
  processingFeeCents?: number;
  /** Omitted/null on dry-run previews */
  pendingLedgerItem?: BillingLedgerEntry | null;
  proposedTier?: string; // Optional, might be present if willChangeTier is true
  capabilitiesLost?: CapabilityDiffItem[];
  capabilitiesGained?: CapabilityDiffItem[];
};

export enum SubscriptionStatus {
  INCOMPLETE = "incomplete",
  INCOMPLETE_EXPIRED = "incomplete_expired",
  TRIALING = "trialing",
  ACTIVE = "active",
  PAST_DUE = "past_due",
  CANCELED = "canceled",
  CANCELLATION_REQUESTED = "cancellation_requested",
  CANCELING = "canceling",
  UNPAID = "unpaid",
  PAUSED = "paused",
  COMPLETE = "complete",
  INACTIVE = "inactive",
}

export type BillingLedgerResponseDto = {
  entries: BillingLedgerEntry[];
  total: number;
};
